import React, { useEffect, useMemo, useState } from "react";
import styles from "../TriggerField.module.scss";
import { TextField } from "@mui/material";
import { CustomDropdown } from "components/shared/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems } from "redux/slices/triggerSlice";
import { setPublish } from "redux/slices/globalSlice";

const optionsArray = [
    { label: "is", value: "is" },
    { label: "contains", value: "contains" },
    { label: "does not contain", value: "does not contain" },
    { label: "is answered", value: "is answered" },
    { label: "is unanswered", value: "is unasnswered" },
];


const MultipleChoiceTrigger = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState({ label: "Multiple Choice", options: item?.operator || "contains", value: item?.value || [] });
    const dispatch = useDispatch();

    const valueOptions = useMemo(() => {
        return (item?.options)?.map(ele => ({ label: ele, value: ele }))
    }, [item])


    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };

            if (name === "options") {
                if (value === "is answered" || value === "is unanswered") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                    };
                }
            }

            return updatedOptions;
        });
    };

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Multiple Choice", 
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);

    useEffect(() => {
        setLocalOptions((prev) => ({
            ...prev,
            options: item?.operator || prev.options,
            value: item?.value || prev?.value
        }));
    }, [item?.operator, item?.value]);

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={item?.label || "Multiple Choice"} disabled name="label" />

                <CustomDropdown
                    width='200px'
                    name="options"
                    options={optionsArray}
                    value={localOptions?.options || ""}
                    onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                />
                {
                    localOptions?.options == "does not contain" || localOptions?.options == "is" ? <CustomDropdown
                        name="value"
                        width='200px'
                        options={valueOptions}
                        value={localOptions?.value || ""}
                        onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                    />
                        :
                        localOptions?.options == "contains" ?
                            <TextField
                                name="value"
                                options={valueOptions}
                                value={localOptions?.value || ""}
                                onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                            />
                            :
                            null
                }
            </div>


            <div
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default MultipleChoiceTrigger;
